<template>
    <div class="main-form">
        <StepNumber
            stepNum = "1"
            totalSteps = "5"
        ></StepNumber>
        <div class="main-form_info">
            <InputRadioButtons
                :options = "$store.state.inputOptionsVariables.producto"
                :title = "$store.state.newTexts.step_productos[0].title"
                :explanation = "$store.state.newTexts.step_productos[0].explanation || ''"
                :selected = "this.$store.state.prescoringData.producto"
                @valueChanged = "(value) => handleValueChanged('producto',value)"
            ></InputRadioButtons>
        </div>
        <NavegationButtons 
            :nextStep = "nextStep"
            backStep = "https://myinvestor.es/hipotecas/"
            :nextStepButtonActive = "canContinue"
            nextStepButtonText = "Continuar"
            backStepButtonText = "Atrás"
        ></NavegationButtons> 
    </div>
</template>

<script>
import StepNumber from '../common/StepNumber.vue'
import NavegationButtons from '../common/NavegationButtons.vue'
import InputRadioButtons from '../common/InputRadioButtons.vue'

export default {
    name: 'step_productos',
    components: {
        StepNumber,
        NavegationButtons,
        InputRadioButtons
    },
    computed: {
        nextStep(){
            if(!this.$store.state.prescoringData.producto) return false;
            if(this.$store.state.prescoringData.producto === 'habitual' || this.$store.state.prescoringData.producto === '2avivienda' || this.$store.state.prescoringData.producto === 'inversion')
                return 'step_datos_vivienda';
            else if(this.$store.state.prescoringData.producto === 'mejorar')
                return 'step_datos_hipoteca_mejora';
            else if(this.$store.state.prescoringData.producto === 'otros')
                return 'productos_helloteca';
            else 
                return false;
        },
        canContinue(){
            return this.$store.state.prescoringData.producto;
        }
    },
    methods: {
        handleValueChanged(field, value){
            this.$store.commit('resetPrescoringData');
            this.$store.commit('updatePrescoringData', { field, value });
        }
    }
}
</script>
